import { SYSTEM_ACCESS_PROFILES } from '../constants/permissions';

/** @deprecated Prefer SYSTEM_ACCESS_PROFILES from constants/permissions */
export const roles = SYSTEM_ACCESS_PROFILES.map((profile, index) => ({
  code: String(index + 1),
  label: profile.code,
}));
